var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeachHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6004246_beach_holiday_sea_summer_sun_icon 1",
    clipPath: "url(#clip0_4407_8973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.492188 23.1551H20.1861C17.5312 20.6251 14.0054 19.2139 10.3391 19.2139C6.67287 19.2139 3.14708 20.6251 0.492188 23.1551Z",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0305 3.36035C16.0305 3.36035 17.8227 6.29165 16.9069 11.0211",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0306 3.36035C16.0306 3.36035 12.7713 4.43434 10.4326 8.66132",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.14 13.3023C21.374 11.8592 19.1718 11.057 16.8921 11.0262C15.0482 9.55538 12.775 8.72683 10.4177 8.66638C8.65259 7.23383 6.45706 6.43732 4.18457 6.40509C5.60532 4.74769 7.50163 3.56824 9.61576 3.02704C11.7299 2.48583 13.9593 2.60914 16.0009 3.38019C18.0666 4.09791 19.8607 5.43593 21.1384 7.21166C22.416 8.98739 23.115 11.1143 23.14 13.3023Z",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0305 3.35999L16.5327 1.9707",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.8642 9.30664L10.2603 19.2139",
    stroke: "#44146c",
    strokeWidth: 1.81904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4407_8973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.557,
    height: 23.6475,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachHoliday);
export default __webpack_public_path__ + "static/media/beach-holiday.825e81d99508683248c46dea0de6742d.svg";
export { ForwardRef as ReactComponent };